import { useState } from 'react';

interface Props {
  onClose: () => void;
  onAdd: (data: { name: string; email: string; password: string; role: string; center?: string }) => void;
}

export default function AddStaffModal({ onClose, onAdd }: Props) {
  const [form, setForm] = useState({
    name: '', email: '', password: '', role: 'coordinator', center: '',
  });
  const [showPw, setShowPw] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onAdd({ ...form, center: form.center || undefined });
  };

  const inputClass = "w-full px-4 py-2.5 text-sm rounded-xl border-2 border-rose-100 bg-rose-50/30 focus:outline-none focus:border-rose-300 transition-all";
  const labelClass = "block text-xs font-semibold text-gray-600 mb-1.5";

  return (
    <div className="fixed inset-0 bg-black/20 z-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl border-2 border-rose-100 w-full max-w-md max-h-[90vh] overflow-y-auto p-6">
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-bold text-gray-800 text-base">הוספת משתמש חדש</h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-xl border-2 border-gray-200 text-gray-400 hover:bg-gray-50 cursor-pointer transition-all"><i className="ri-close-line text-base"></i></button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div><label className={labelClass}>שם מלא *</label><input type="text" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required placeholder="שם העובד..." className={inputClass} /></div>
          <div><label className={labelClass}>אימייל *</label><input type="email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} required placeholder="email@example.com" className={inputClass} /></div>
          <div>
            <label className={labelClass}>סיסמה *</label>
            <div className="relative">
              <input type={showPw ? 'text' : 'password'} value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} required placeholder="********" className={inputClass + ' pl-10'} minLength={8} />
              <button type="button" onClick={() => setShowPw((v) => !v)} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer">
                <i className={`${showPw ? 'ri-eye-off-line' : 'ri-eye-line'} text-sm`}></i>
              </button>
            </div>
          </div>
          <div>
            <label className={labelClass}>תפקיד</label>
            <select value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))} className={inputClass}>
              <option value="admin">מנהל מערכת</option>
              <option value="coordinator">רכז</option>
            </select>
          </div>
          <div><label className={labelClass}>מרכז / אזור</label><input type="text" value={form.center} onChange={(e) => setForm((f) => ({ ...f, center: e.target.value }))} placeholder="תל אביב..." className={inputClass} /></div>
          <div className="flex gap-3 pt-2">
            <button type="submit" className="flex-1 py-2.5 rounded-xl bg-rose-400 text-white text-sm font-bold hover:bg-rose-500 transition-all cursor-pointer whitespace-nowrap">הוסף משתמש</button>
            <button type="button" onClick={onClose} className="px-5 py-2.5 rounded-xl border-2 border-gray-200 text-gray-500 text-sm font-semibold hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap">ביטול</button>
          </div>
        </form>
      </div>
    </div>
  );
}
